import { useCallback, useContext } from "react";

import dayjs from "dayjs";

import { GenericDataFormContext } from "../../../shared/contexts/GenericDataForm";
import { StepThreeFormContext } from "../contexts/StepThreeForm";

import { PAYMENT_METHODS } from "../../../shared/utils/methods-payment.enum";

export const useFileNameHandler = () => {
  const { preliquidationInfo } = useContext(GenericDataFormContext);

  const {
    stepThreePaymentMethodForm,
    paymentMethodFormValues,
    banksOptions,
    paymentMethodSequence,
  } = useContext(StepThreeFormContext);

  const setFileNameByPaymentMethod = useCallback(
    (fileSelected:any[]) => {
      if (!fileSelected?.[0]?.name) return "Ningún archivo seleccionado...";

      const preliquidationNumber = preliquidationInfo?.numeroPreliquidacion!;
      
      const bankSelected: string =
        banksOptions
          ?.find(
            (el) =>
              el.value === stepThreePaymentMethodForm?.getFieldValue("bank")
          )
          ?.label.replace(/\s+/g, "") ?? "";
      const transferDateToken = paymentMethodFormValues?.transferDate
        ? dayjs(paymentMethodFormValues?.transferDate).format("YYYY-MM-DD")
        : " ";

      let newFileName = "";

      switch (Number(paymentMethodFormValues?.paymentMethod)) {
        case PAYMENT_METHODS.ELECTRONIC_CHECK:
          newFileName = `CHEQUEELECTRONICO_${preliquidationNumber}_${bankSelected}_${dayjs(
            paymentMethodFormValues?.checkDate
          ).format("YYYYMMDD")}_${paymentMethodSequence}.${
            fileSelected[0].type
          }`;
          break;
        case PAYMENT_METHODS.ROUNDING:
          newFileName = `REDONDEO_${preliquidationNumber}_${paymentMethodSequence}.${fileSelected[0].type}`;
          break;
        case PAYMENT_METHODS.BANK_DEPOSIT:
          newFileName = `RECIBOTRANSFERENCIA_${preliquidationNumber}_${bankSelected}_${transferDateToken}_${paymentMethodSequence}.${
            fileSelected[0].type
          }`;
          break;
        case PAYMENT_METHODS.GALICIA_INTEGRATED_COLLECTION:
          newFileName = `COBRANZAINTEGRADA_${preliquidationNumber}_${paymentMethodSequence}.${fileSelected[0].type}`;
          break;
        case PAYMENT_METHODS.TAX_WITHHOLDING:
          newFileName = `RETENCION_PRELIQUIDACION_${preliquidationNumber}_${paymentMethodSequence}.${fileSelected[0].type}`;
          break;
        default:
          newFileName = "Ningún archivo seleccionado...";
          break;
      }

      if (fileSelected[0]) {
        fileSelected[0].name = newFileName;
      }

      return newFileName;
    },
    [paymentMethodFormValues, stepThreePaymentMethodForm, banksOptions, paymentMethodSequence]
  );

  return {setFileNameByPaymentMethod}
};